'use client';

import { DropdownMenu, Icon } from '~/components/primitives';

export const StaffPartnerActions: React.FC<{
    activityId: number;
    groupId?: number | string | null;
    pdfSheets: Array<{ name: string; path: string; language: string | null }>;
}> = ({ activityId, groupId, pdfSheets }) => {
    return (
        <DropdownMenu
            enabled
            as="button"
            position="bottom-end"
            content={
                <menu className="min-w-48">
                    <a
                        href={`/admin/activities/${activityId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex w-full items-center gap-3 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800"
                    >
                        <Icon
                            name="external-link"
                            size="sm"
                            color="none"
                            className="text-gray-400"
                        />
                        admin/activity - id:{activityId}
                    </a>
                    {groupId != null && (
                        <a
                            href={`/admin/groups/${groupId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex w-full items-center gap-3 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800"
                        >
                            <Icon
                                name="external-link"
                                size="sm"
                                color="none"
                                className="text-gray-400"
                            />
                            admin/group - id:{groupId}
                        </a>
                    )}
                    {pdfSheets.map(sheet => (
                        <a
                            key={sheet.path}
                            href={sheet.path}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex w-full items-center gap-3 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800"
                        >
                            <Icon
                                name="download"
                                size="sm"
                                color="none"
                                className="text-gray-400"
                            />
                            PDF {sheet.language?.toUpperCase() ?? sheet.name}
                        </a>
                    ))}
                </menu>
            }
        >
            <div
                className="flex h-7 w-7 items-center justify-center rounded-md text-blue-500 transition hover:bg-blue-100"
                title="Actions"
            >
                <Icon name="dots-vertical" size="sm" />
            </div>
        </DropdownMenu>
    );
};
